import { db } from "../firebase/config";

import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";

const invoiceCollectionRef = collection(db, "invoice");

const generateInvoiceId = async () => {
  try {
    const allInvoices = await getAllInvoice();

    // Regular expression to match valid invoice IDs
    const invoicePattern = /^INV-(\d{5})$/;

    // @ts-ignore
    const validInvoiceNumbers = allInvoices
      // @ts-ignore
      .map((invoice) => invoicePattern.exec(invoice.invoice))
      // @ts-ignore
      .filter((match) => match !== null)
      // @ts-ignore
      .map((match) => parseInt(match[1]));

    // Find the highest invoice number
    const highestInvoiceNumber =
      validInvoiceNumbers.length > 0 ? Math.max(...validInvoiceNumbers) : 0;

    // Generate the next invoice number
    const nextInvoiceNumber = highestInvoiceNumber + 1;
    const paddedNextInvoiceNumber = nextInvoiceNumber
      .toString()
      .padStart(5, "0");

    return `INV-${paddedNextInvoiceNumber}`;
  } catch (error) {
    console.error("Error generating invoice ID:", error);
    throw error;
  }
};

const getAllInvoicesOfCustomer = async (customerId) => {

  const invoiceSnapshot = await getDocs(invoiceCollectionRef);
  const invoiceList = invoiceSnapshot.docs.map((doc) => {
    return {
      ...doc.data(),
      id: doc.id,
    };
  });

  invoiceList.forEach((inv, index) => {
  });

  // @ts-ignore
  const invoice = invoiceList.filter(
    (invoice) => invoice.customerId === customerId
  );


  if (invoice) {
    return invoice;
  } else {
    return null;
  }
};

const getAllInvoice = async () => {
  const invoiceSnapshot = await getDocs(invoiceCollectionRef);
  const invoiceList = invoiceSnapshot.docs.map((doc) => {
    return {
      ...doc.data(),
      id: doc.id,
    };
  });
  return invoiceList;
};

const createInvoice = async (invoice) => {
  const docRef = await addDoc(invoiceCollectionRef, invoice);
  return {
    id: docRef.id,
    ...invoice,
  };
};

const updateInvoice = async (invoice) => {
  const docRef = doc(db, "invoice", invoice.id);
  await updateDoc(docRef, invoice);
  return invoice;
};

const deleteInvoice = async (id) => {
  const docRef = doc(db, "invoice", id);
  await deleteDoc(docRef);
};

const getInvoiceById = async (id) => {
  const docRef = doc(db, "invoice", id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return {
      id: docSnap.id,
      ...docSnap.data(),
    };
  } else {
    return null;
  }
};

const getInvoiceByInvoiceNumber = async (invoiceNumber) => {
  const invoiceSnapshot = await getDocs(invoiceCollectionRef);
  const invoiceList = invoiceSnapshot.docs.map((doc) => {
    return {
      ...doc.data(),
      id: doc.id,
    };
  });
  // @ts-ignore
  const invoice = invoiceList.find(
    (invoice) => invoice.invoice === invoiceNumber.toString()
  );

  if (invoice) {
    return invoice;
  } else {
    return null;
  }
};

export {
  getAllInvoice,
  createInvoice,
  updateInvoice,
  deleteInvoice,
  getInvoiceById,
  getInvoiceByInvoiceNumber,
  generateInvoiceId,
  getAllInvoicesOfCustomer,
};
